module.exports = __webpack_public_path__ + "static/media/stream_intensati_video_classes.431e550d.svg";